import { useMemo } from 'react';
import { Link } from 'react-router';
import { useLiveQuery } from 'dexie-react-hooks';
import { Banner } from '@/components/Banner';
import { hayDatosCapturados } from '@/db/schema';
import { detectarPlataforma } from './platform';

/**
 * Aviso de almacenamiento separado en iOS (Req. 2.6).
 *
 * En iOS la app instalada en la pantalla de inicio NO comparte IndexedDB con
 * Safari. Si se captura informacion en Safari, no aparecera en la app
 * instalada, y esa confusion se siente como una perdida de datos.
 *
 * Por eso hay dos mensajes distintos:
 *   - Con datos capturados en Safari -> advertencia de almacenamiento separado.
 *   - Sin datos                      -> invitacion a instalar.
 */
export function StandaloneNotice() {
  const plataforma = useMemo(() => detectarPlataforma(), []);
  const hayDatos = useLiveQuery(() => hayDatosCapturados(), [], false);

  // En la app instalada no hay nada que advertir.
  if (plataforma.enStandalone) return null;

  if (hayDatos === true) {
    return (
      <Banner tono="alerta" titulo="Estas usando el navegador, no la app instalada">
        <p>
          Los datos que captures aqui <strong>no apareceran</strong> en la app instalada en
          tu pantalla de inicio: iOS guarda cada una por separado.
        </p>
        <p className="mt-2">
          Para no dividir tu informacion, captura siempre desde la app instalada. Si ya
          registraste algo aqui, exportalo en{' '}
          <Link to="/respaldos" className="font-medium text-marca underline">
            Respaldos
          </Link>{' '}
          e importalo desde la app instalada.
        </p>
      </Banner>
    );
  }

  return (
    <Banner tono="aviso" titulo="Instala la aplicacion antes de capturar datos">
      <p>
        En iOS la app instalada y Safari guardan datos por separado. Instalala primero para
        que toda tu informacion quede en un solo lugar.
      </p>
      <p className="mt-2">
        <Link to="/instalar" className="font-medium text-marca underline">
          Ver como instalarla
        </Link>
      </p>
    </Banner>
  );
}
